  // src/components/Hero.jsx
  import React from "react";
  import { getPortfolioData } from "../../data/portfolioData";
  import { TypeAnimation } from "react-type-animation";
  import { FaInstagram, FaLinkedinIn, FaWhatsapp } from "react-icons/fa";
  import "./Herosection.css";
  import Button from "../button/Button";
  // import Button from "../button/Button";
  import profileImg from "../../assets/profile.png";

  const Hero = ({ setActiveSection }) => {
    const { herosection, contact} = getPortfolioData();

    return (
      <section className="hero-section" id="hero">
        <div className="hero-container">

          <div className="hero-container-left">
            <img src={profileImg} alt="Best Freelance Developer" className="mobile-profile-image" />
            <h1>
              Hi, I'm{" "}
              <TypeAnimation
                sequence={[
                  `${herosection.firstName}`,
                  2000,
                  ...herosection.role.flatMap((role) => [`a ${role}`, 2000]),
                ]}
                wrapper="span"
                speed={50}
                repeat={Infinity}
                className="typing-text"
              />
            </h1>
            <p>{herosection.description}</p>
            <h6>Follow me on</h6>
            <div className="social-media-btn">
              <a href={contact.instagram} target="_blank" rel="noreferrer">
                <FaInstagram />
              </a>
              <a href={contact.whatsapp} target="_blank" rel="noreferrer">
                <FaWhatsapp />
              </a>
              <a href={contact.linkedIn} target="_blank" rel="noreferrer">
                <FaLinkedinIn />
              </a>
            </div>
            <Button
              name={"Send Message"}
              className={"send-msg"}
              onClick={() => setActiveSection("contact")}
            />
          </div>
        </div>
      </section>
    );
  };

  export default Hero;
